//双语规范的变量(中文)

export const zhm = {

  'index':'代理平台',
  'User_Name1':'用户名',
  'User_Name2':'账号',
  'User_Name3':'被进分账号',
  'User_Name4':'被操作者',

  'Password1':'密 码',
  'Password2':'密码',
  'OK1':'修改',
  'OK2':'确定',

  'Name1':'真实姓名',
  'Name2':'名字',

  'Description1':'备注',
  'Description2':'描述',

  'Set_score1':'进分',
  'Set_score2':'设定分数',

  'Account1':'操作者',
  'Account2':'进分账号',

  'Date_Time1':'日期时间',
  'Date_Time2':'日期',

  'Login':'登录',
  'Please_enter_your_account_number':'请输入账号',
  'Please_enter_your_password':'请输入密码',
  'Please_enter_the_2nd_security_password':'请再次输入新密码',
  'personal_2_Password':'二级密码登录',
  'Change_Password':'修改密码',
  'Old_password':'旧密码',
  'New_password':'新密码',
  'Confirm_new_password':'确认新密码',
  'Please_enter_your_old_password':'请输入旧密码',
  'Please_confirm_your_new_password':'请确认新密码',

  'Cancel':'取消',
  'my_score':'我的分数',
  'Password_mismatch':'两次密码不一致',
  'Change_personal_2_Password':'修改私人密码',
  'Old_personal2_password':'旧私人密码(二级密码)',
  'New_personal2_password':'新私人密码(二级密码)',
  'Confirm_new_personal2_password':'确认私人密码(二级密码)',

  'user_management':'账号管理',
  'agent_list':'代理列表',
  'Add_Agent':'新增代理',
  'new_store':'新增门店',
  'Agent_total_report':'代理总账',
  'Reload_agent_List':'刷新代理列表',
  'Score':'分数',
  'Tel':'电话',
  'Operation':'操作',
  'score_log':'进分记录',
  'edit':'编辑',
  'report':'查账',
  'disable':'禁用',
  'Current_score':'当前分数',
  'Back':'返回上一页',
  'Score_nonzero_hint':'请输入大于0或小于0的数字',
  'Successful_operation1':'分数设置成功',
  'Max_value':'最大值：',
  'Player_Records':'玩家记录',
  'Agent_Records':'代理记录',
  'Player_Account':'玩家账号',
  'Agent_Account':'代理账号',
  'Start_date':'开始日期',
  'End_date':'结束日期',
  'Select_Date':'选择时间',
  'TO':'至',
  'Before_Score':'之前分数',
  'After_Score':'之后分数',
  'IP':'操作IP',

  'Edit_agent':'编辑代理',
  'User_agent':'上级代理',
  'Successful_operation':'修改成功',
  'No_Data':'暂无数据',
  'Total_win':'总赢钱',
  'Win':'赢钱',
  'enable':'解禁',

  'player_list':'玩家列表',
  'Add_Player':'新增玩家',
  'Player_total_report':'玩家总账',
  'Enable_all_player':'解禁所有玩家',
  'Disable_all_player':'禁用所有玩家',
  'Confirm_ban_all_players':'确定要禁用所有玩家吗？',
  'Confirm_enable_all_players':'确定要解禁所有玩家吗？',
  'Confirm_ban_proxy':'确定要禁用该代理吗？',
  'Confirm_enable_proxy':'确定要解禁该代理吗？',
  'Confirm_ban_user':'确定要禁用该玩家吗？',
  'Confirm_enable_user':'确定要解禁该玩家吗？',
  'Cannot_ban_self':'不能禁用自己',
  'Reload_player_List':'刷新所有玩家',
  'Get_data_successfully':'获取数据成功',
  'Last_login_time':'最后登录时间',
  'game_log':'游戏记录',
  'Bonus_log':'彩金记录',
  'Game_Name':'游戏名称',
  'Begin_Money':'开始金额',
  'Bet':'押注',
  'End_Money':'结束金额',
  'Bonus_Amount':'彩金金额',
  'Sign_out':'退出登录',
  'Operation_log':'操作记录',
  'Action_Type':'动作类型',

  'Please_select':'请选择',
  'Private_password_info': '为了安全起见，请设置您的二级安全密码，\n' +
    '      并在每次登录时重新确认二级安全密码。\n' +
    '      管理员无法查看或编辑您的二级安全密码。\n' +
    '      如果您忘记或输入错误密码5次，\n' +
    '      请联系管理员申请新的二级安全密码。\n' +
    '      重置后，请立即更改您的二级安全密码。\n' +
    '      您的二级安全密码必须至少为6位数字，且不能太简单',

  'The_length_is_716_characters':'长度在7-16位',
  'The_length_is_11_characters':'长度在11位',
  'Username_format_hint':'请输入字母或数字或组合',
  'The_length_is_616_characters':'长度在6-15位',
  'Password_format_hint_strict':'密码至少 6 位,必须是数字和字母组合.其中至少有一位字母大写和一位字母小写,密码中可以有! - _ 这三个符号.',
  'Password_format_hint':'密码至少 6 位，必须由数字和字母组合而成。可以包含 ! - _ 符号。',
  'Password_no_consecutive':'不能输入3位以上连续的数字和字母',
  'Please_enter_a_score':'请输入分数',
  'Score_must_be_numeric':'请输入数字',
  'Please_enter_a_numeric_value':'私人密码(二级密码)必须是6位纯数字，并且不能过于简单.',
  'Please_enter_the_correct_score_format':'请输入正确格式分数',
  'Enter_up_to_two_decimal_places':'最多输入两位小数',
  'Enter_up_to_three_decimal_places':'最多输入三位小数',
  'Failed_to_get_agent':'获取代理失败',
  'Exceeding_the_maximum_value':'超出最大值',
  'Score_must_be_positive':'创建失败，分数设定需要大于0',
  'Add_successfully':'添加成功',
  'Failed_to_add_agent':'添加代理失败',
  'Failed_to_add_player':'添加玩家失败',
  'Failed_to_get_player':'获取玩家失败',
  'Modification_successful':'修改成功',
  'Modification_failed':'修改失败',

  "Personal_secondary_security_password": "个人二级安全密码",
  "Confirm_personal_secondary_security_password": "确认个人二级安全密码",
  "Personal_secondary_password": "个人二级密码",

  "The_length_is_6_characters": "长度为6位",
  "The_length_is_8_characters": "长度为8位",
  "Private_password_hint": "私人密码(二级密码)必须是6位纯数字，并且不能过于简单.",
  "Password_same_as_old": "新密码与旧密码一致",
  "Password_mismatch_error": "修改失败，两次密码不一致",
  "Password_used_before": "修改失败，新密码与旧密码一致",

  "Change_success_relogin": "修改成功！点击\"确定\"后重新登录后台",
  "Confirm_Logout": "确定退出登录?",
  "Logged_out": "已退出登录！",
  "Add_failed": "添加失败",
  "Login_Failed": "登录失败",
  "Failed_Operation": "分数设置失败",
  "Last_week": "最近一周",
  "Last_month": "最近一个月",
  "Last_three_months": "最近三个月",
  "Please_enter_the_time": "请输入时间",
  "Failed_to_obtain_data": "获取数据失败",
  "agent": "代理",
  "Functional_Description": "功能描述",
  "Enable_the_function": "开启功能",
  "Creation_Date": "创建时间",
  "Modify_permissions": "修改权限",
  "Is_auditing_enabled": "是否开启查账",
  "Is_to_score": "是否可以进分",
  "Can_new_account": "是否可以新开账号",
  "Is_disable_unban_account": "是否可以禁用/解禁账号",
  "Can_edit_account": "是否可以编辑账号",
  "Is_disable_unban_sub_accounts": "是否可以禁用/解禁子账号",

  "Allow_audit":"允许查账",
  "Allow_to_score":"允许进分",
  "Allow_new_accounts":"允许新开账号",
  "Allow_disabling_unbanning_accounts":"允许禁用/解禁账号",
  "Allow_account_editing":"允许编辑账号",
  "Allow_disabling_unbanning_subaccounts":"允许禁用/解禁子账号",
  "Please_select_permissions": "请选择权限",

  "Operator": "操作者",
  "Operated": "被操作者",
  "Set_score_player": "给玩家设定分数",
  "Set_score_agent": "给代理设定分数",
  "Add_players": "新增玩家",
  "Add_NEW_Agent": "新增代理",
  "Add_subaccount": "新增子账号",
  "Unban_all_players": "解禁所有玩家",
  "Ban_All_Players": "禁用所有玩家",
  "Unban_players": "解禁玩家",
  "Ban_Player": "禁用玩家",
  "Edit_Player_Information": "编辑玩家信息",
  "Edit_Agent_Information": "编辑代理信息",
  "Unban_single_agent": "解禁单个代理",
  "ban_single_agent": "禁用单个代理",
  "Sub_account": "子账号",
  "Edit_User": "编辑用户",
  "General_ledger_audit": "总账查询",
  "Search_Account": "搜索帐号",
  "Sub_account_management":"子账号管理",
  "Modify_subaccount_permissions": "修改子账号权限",

  "act_1_1": "给玩家进分数：",
  "act_1_2": " --- 为帐号：",
  "act_1_3": " 设定分数控制成功，分数为：",
  "act_1_4": " 代理之前分:",
  "act_1_5": "  现在为:",

  "act_2_1": "给代理进分数：",
  "act_2_2": " --- 为帐号：",
  "act_2_3": " 设定分数控制成功，分数为：",
  "act_2_4": " 代理之前分:",
  "act_2_5": "  现在为:",

  "act_3_1": "新增玩家：",
  "act_3_2": " --- 新增账号：",
  "act_3_3": "成功",

  "act_4_1": "新增代理：",
  "act_4_2": " --- 新增代理：",
  "act_4_3": "成功",

  "act_5_1": "新增子账号：",
  "act_5_2": " --- 新增子账号：",
  "act_5_3": "成功",

  "act_6_1": "解禁所有玩家：",
  "act_6_2": " --- 解禁：",
  "act_6_3": "所有玩家成功",

  "act_7_1": "禁用所有玩家：",
  "act_7_2": " --- 禁用：",
  "act_7_3": "所有玩家成功",

  "act_8_1": "解禁单个账号：",
  "act_8_2": " --- 解禁账号：",
  "act_8_3": "成功",

  "act_9_1": "禁用单个账号：",
  "act_9_2": " --- 禁用账号：",
  "act_9_3": "成功",

  "act_10_1": "编辑账号信息：",
  "act_10_2": " --- 更新玩家账号：",
  "act_10_3": "信息成功",

  "act_11_1": "编辑账号信息：",
  "act_11_2": " --- 更新代理账号：",
  "act_11_3": "信息成功",

  "Limit_reached": "创建代理已达到上限",
  "UserId_must_be_7_digits": "必须为7位数字",
  "Begin_Date": "开始时间",
  "End_Date": "结束时间",
  "Select_date": "选择日期",
  "Select_time": "选择时间",
  "Bonus_Amount": "奖金金额",

  "AgentList_Menu": "代理列表菜单",
  "PlayerList_Menu": "玩家列表菜单",
  "DisOnlineDay": "离线多久",
  "days": "天前",
  "off": "",
  "online": "在线",
  "table_id": "桌子ID",
  "ranking": "排行榜",
  "ranking1": "排名",
  "coding_volume": "活动打码量",
  "reward": "奖金金额",
  "Winning_time": "中奖时间",
  "Total_pay": "总上分",
  "Total_withdraw": "总下分",
  "Available_withdraw": "可下分",
}



// WEBPACK FOOTER //
// ./src/lang/zh.js